import React from 'react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Paper, Box, Button } from '@material-ui/core';

import { useTranslations } from 'components/utilities';
import { resetCarParamsContext, signOut } from 'store/actions';
import { APP_PATHS } from 'components/routes/paths';

const BookingDetailsFooter = ({ boxPaddings, isDesktop }) => {
	const { t } = useTranslations();

	const dispatch = useDispatch();

	const history = useHistory();

	const resetKiosk = () => {
		resetCarParamsContext()(dispatch);
		signOut()(dispatch);
		history.push(APP_PATHS.START);
	};

	return (
		<Paper>
			<Box {...boxPaddings}>
				<Box mt={2} mb={isDesktop ? 0 : 4}>
					<Button
						variant="contained"
						color="primary"
						size={isDesktop ? 'large' : 'medium'}
						fullWidth
						onClick={resetKiosk}
					>
						{t('booking.submit')}
					</Button>
				</Box>
			</Box>
		</Paper>
	);
};

export default BookingDetailsFooter;
